// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgLogoutIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M15.707 6.293a1 1 0 1 0-1.414 1.414L17.586 11H9a1 1 0 1 0 0 2h8.586l-3.293 3.293a1 1 0 0 0 1.414 1.414l4.93-4.93a1.1 1.1 0 0 0 0-1.555z" />
    <path fillRule="evenodd" d="M3 2h8.5a1 1 0 1 1 0 2H5v16h6.5a1 1 0 1 1 0 2H3z" />
  </g>
);
export default SvgLogoutIcon;
SvgLogoutIcon.displayName = 'SvgLogoutIcon';
